import React from 'react';
import { Link } from 'react-router-dom'
import icon1 from '../../assets/images/icon/Wallet.png'
import icon2 from '../../assets/images/icon/Category.png'
import icon3 from '../../assets/images/icon/Image2.png'
import icon4 from '../../assets/images/icon/Bookmark.png'

const Create = () => {
    const data = [
        {
            title: "Solicite seu orçamento e receba em até 24h",
            description: "Deixe seu contato e receba um orçamento personalizado para o seu projeto.",
            icon : icon1,
            colorbg : "icon-color1"
        },
        {
            title: "Planeje junto com nossa equipe",
            description: "Nossa equipe de especialistas irá te ajudar a planejar o seu projeto e tirar todas as suas dúvidas.",
            icon : icon2,
            colorbg : "icon-color2"
        },
        {
            title: "Desenvolvemos o Layout e mostramos para você",
            description: "Nossa equipe de designers irá criar o layout do seu projeto e te mostrar para aprovação.",
            icon : icon3,
            colorbg : "icon-color3"
        },
        {
            title: "Conclusão do projeto",
            description: "Após a aprovação do layout, nossa equipe de desenvolvedores irá criar o seu projeto e te entregar com a melhor qualidade.",
            icon : icon4,
            colorbg : "icon-color4"
        },
    ]
    return (
        <section className="tf-box-icon create style1 tf-section">
            <div className="themesflat-container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="heading-live-auctions mg-bt-22">
                            <h2 className="tf-title pb-17">
                                Criamos tudo do seu jeito!
                            </h2>                         
                        </div>
                    </div>
                    {
                        data.map((item , index) => (
                            <CreateItem key={index} item={item} />
                        ))
                    }
                </div>                 
            </div>
        </section>
    );
}

const CreateItem = props => (
    <div className='col-lg-3 col-md-6 col-12'>
        <div className="sc-box-icon">
            <div className="image">
                <div className={`icon-create ${props.item.colorbg}`}>
                    <img src={props.item.icon} alt="" />
                </div>                                                                             
            </div>
            <h3 className="heading"><Link to="/wallet-connect">{props.item.title}</Link></h3>
            <p className="content">{props.item.description}</p>
        </div>
    </div>
)

export default Create;
